import { Professional } from '@abiglobalhealth/go-types'
import { Modal } from '@components/Modal'
import { useTranslation } from 'react-i18next'

import { ConsultationIcon } from '@/components/Consultation/components/ConsultationIcon'
import { useConsultationType } from '@/hooks/useConsultationType'
import { getProfessionalKey } from '@/locale/utils'

interface ProfessionalDetailProps {
  professional: Professional
  onClose: () => void
}

export const ProfessionalDetail = ({ professional, onClose }: ProfessionalDetailProps) => {
  const { t } = useTranslation()
  const { consultationType } = useConsultationType()

  return (
    <Modal
      header={{
        icon: <ConsultationIcon consultationType={consultationType} customClassName="h-7 text-primary" />,
        title: t(getProfessionalKey(professional), {
          name: professional.name
        })
      }}
      onClose={onClose}
      dataTestId="professional-detail-modal"
      fullScreen
    >
      <iframe src={professional.profileUrl} className="bg-gray-background w-full flex-1 rounded-sm p-2 shadow-sm" />
    </Modal>
  )
}
